import CustomReusableDownloadToaster from "@bevco/Components/CustomReusableDownloadToaster";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import React from "react";
import { css } from "styled-components";

const GlobalElementsPage = ({ id }: PageProps) => {
    const pageStyles = css`
        padding-bottom: 0;
        padding-top: 0;
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: 9999;
    `;

    return (
        <Page as="div" fullWidth={[true, true, true, true, true]} css={pageStyles} background="transparent">
            <CustomReusableDownloadToaster />

            <Zone contentId={id as never} zoneName={"Content" as never}></Zone>
        </Page>
    );
};

const pageModule: PageModule = {
    component: GlobalElementsPage,
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: false,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;
